export const formatCostAsNumber = val => {
  if (val === 'FREE') {
    return 0;
  }
  const newVal = val?.replace('$', '');
  const number = Number(newVal);
  if (isNaN(number))
    throw new Error(`Cannot format "${val}" as a cost, as it becomes NaN`);
  return newVal;
};
